import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useReactToPrint } from 'react-to-print';

import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,Divider,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, List,InputNumber,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    SaveOutlined,
    ShoppingCartOutlined,
    DeleteOutlined
} from '@ant-design/icons';

import './styles.scss'

import moment from 'moment'
import {getData,editItem,addItem,deleteItem,updateItem} from '../../../Redux/actions/crudActions'
import {setPrice} from '../../../Redux/actions/productActions'
import {addCartItem,getCart,deleteCartItem,editCartItem,clearCart} from '../../../Redux/actions/cartActions'
import {createPackage,getPackageData} from '../../../Redux/actions/packageActions'

import {errorParser} from '../../../utils/helpers'

import CreateForm from '../../Generic/CreateForm'
import InputSelect from '../../Generic/InputSelect'
import ImageChecker from '../../Generic/ImageChecker'
import QRCode from "react-qr-code";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({currentItem}) => { 
    
    const dispatch = useDispatch()    
    const { user,cart,locations } = useSelector(state => ({
      user: state.auth.user,
      cart: state.cart.data,
      locations: state.locations.locations 
    }), shallowEqual)

    const componentRef = useRef();

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [mfgdate, setmfgdate] = useState(null);



    useEffect(() => {
 
    },[]);


    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });
    

    const trytoprint =()=>{
      if(mfgdate){
        handlePrint()
      }else{
        message.error('Enter Manufacturing Date')
      }
    }

 

    return(       
      <>   
      <div className={'printItemhide'}>
      <ComponentToPrint ref={componentRef} pageStyle={pageStyle} currentItem={currentItem} mfgdate={mfgdate}/>
      </div>
      {currentItem.shelf_life && currentItem.expires ? 
        <Button onClick={(e)=>{e.stopPropagation();setIsModalVisible((true))}}  style={{marginTop:'1ch'}}>Print QR</Button>     
      :      
        <Button onClick={(e)=>{e.stopPropagation(); handlePrint();}} style={{marginTop:'1ch'}}>Print QR</Button>
      }
      <Modal title="Manufacturing Date" width={'30ch'}  loading={mfgdate == null}
        visible={isModalVisible} onOk={()=>{trytoprint()}} onCancel={()=>{setIsModalVisible(false)}}>
        <DatePicker onChange={(e)=>{setmfgdate(e)}} />
      </Modal>
      </>
    )
}
  
export default Index
  

const pageStyle = `
  @page {
    size:60mm 40mm;
  }

  @media all {
    .pagebreak {
      display: none;
    }
  }

  @media print {
    .pagebreak {
      page-break-before: always;
    }
  }
`;

const ComponentToPrint = React.forwardRef((props, ref) => {

  const { user,cart,locations } = useSelector(state => ({
    user: state.auth.user,
    cart: state.cart.data,
    locations: state.locations.locations 
  }), shallowEqual)

  // console.log(props.currentItem)
  var dest = locations.filter(i =>i.id == props.currentItem.destination)
    var destData = dest[0]
    
  const productQR = () =>{

    return(
      <div  className={'waybill'}>   
        <div className={'waybill_content'}>
        
            <span> {props.currentItem.name} </span>  
          <div>
            <QRCode value={`prod_${props.currentItem.id}`} size={125}/>
          </div>
         
            <span className={'medText'}> sku : {props.currentItem.sku}</span> 
            <span className={'medText'}> unit : {props.currentItem.unit}</span>   
            <span className={'small_text'}>{`prod_${props.currentItem.id}`}</span>
            {props.currentItem.shelf_life && props.currentItem.expires ?
            <span className={'medText'}>{`expiry: ${moment(props.mfgdate).add(props.currentItem.shelf_life,'months').format('LLL')}`}</span> 
            :null}
            {props.currentItem.shelf_life && props.currentItem.expires ?
            <span className={'medText'}>{`made at: ${moment(props.mfgdate).format('LLL')}`}</span> 
            :
            <span className={'medText'}>{`made at: ${moment().format('LLL')}`}</span> 
            }
        

        </div>  
   
      </div>
    )
  }


  return (
    <div ref={ref}  pageStyle={pageStyle} className={'waybill_container'}> 
  
      {productQR()}

    </div>
  );
});